import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AccountMenu from '../AccountMenu';
import LogoLink from '../LogoLink';
import './DashboardNavbar.css';
import { Outlet, useLocation } from 'react-router-dom';
import UserCreditsView from './UserCreditsView';

const DashboardNavbar: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isTelemetry = location.pathname.startsWith('/dashboard/telemetry/');

  return (
    <>
    <nav className={`navbar navbar-expand-lg mb-3${isTelemetry ? ' telemetry-compact' : ''}`}>
      <div className="container dashboard-navbar">
        <LogoLink
          className="navbar-brand"
          imgClassName="me-2 dashboard-navbar-logo"
          height={isTelemetry ? 40 : undefined}
        />
        <div className="d-flex align-items-center gap-3">
          <UserCreditsView />
          <AccountMenu user={user} onLogout={logout} />
        </div>
      </div>
    </nav>
    <Outlet />
    </>
  );
};

export default DashboardNavbar;
